// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2923149e","453":"8c50dc9d","732":"d695d13d"}[chunkId] + ".chunk.js";
};